var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-watch"},[_c('h1',[_vm._v("Our enagement video")]),_vm._v(" "),_c('p',[_vm._v("Evan's father, Sean, put together this amazing video for our rehearsal dinner. We feel so blessed to have such an amazing work of art of our lives coming together")]),_vm._v(" "),_c('youtube')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f838c902","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Watch.vue
// module id = 91
// module chunks = 0